import {Component, OnInit} from '@angular/core';
import {BannerService} from '@services/banner/banner.service';

@Component({
    selector: 'app-banner-detail',
    templateUrl: 'banner-detail.component.html',
    styleUrls: ['banner-detail.component.scss'],
    providers: [BannerService],
    standalone: false
})

export class BannerDetailComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
